export const swapTags = (text: string, tag: string, value: string | null, fallback: string): string => {
    try {
        // regex replace has better performance than replaceAll
        const re = new RegExp(`{{${tag}}}`,'g');
        if (value) {
            return text.replace(re, value);
        }
        if (fallback) {
            return text.replace(re, fallback);
        }

        /*
         * If the tag is replaced by an empty space, we might as well trim the prefix whitespace, e.g. 'Hello,' instead of 'Hello ,'
         * CKE exports content of whitespace as HMTL entity &nbsp;
         * We chose not to "sanitize" the whole text since replacing all those entities could break the email, so only replacing when needed instead.
        */
        return text.replace(new RegExp(`( |&nbsp;)?{{${tag}}}`,'g'), '');
    } catch (err) {
        throw new Error(`Could not swap tags: ${err}`);
    }
};
